import React from "react";
import { TabbedShowLayout, Tab, TopToolbar, ShowProps } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import Financial from "./Financial";
import Student from "./Student";
import { Grid } from "@material-ui/core";
import InactiveParentButton from "./components/InactiveParentButton";
import ActivateParentButton from "./components/ActivateParentButton";
import InternalNote from "./InternalNote";
import SharedStudent from "./SharedStudent";
import ShowWrapper from "../../components/ShowWrapper";

const ParentShowAction = (props: any) => {
  const { data } = props;
  return (
    <TopToolbar>
      {data && (
        <>
          {data.status === "active" ? (
            <InactiveParentButton parentId={data.id} />
          ) : (
            <ActivateParentButton parentId={data.id} />
          )}
        </>
      )}
    </TopToolbar>
  );
};

const ParentShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/parents", title: "Parents" },
    { link: `/parents/${id}`, title: id },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        isFullName
        actions={<ParentShowAction />}
        isHaveSchoolFilter
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Financial">
                <Financial {...props} />
              </Tab>
              <Tab label="Student">
                <Student {...props} />
              </Tab>
              <Tab label="Shared Student">
                <SharedStudent {...props} />
              </Tab>
              <Tab label="Internal Note">
                <InternalNote {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default ParentShow;
